import React from 'react'
import Icon from './'

const ChevronDown = props => (
  <Icon {...props}>
    <path d="M32.07,49.71a4.42,4.42,0,0,1-3.13-1.29L2.37,21.85a4.43,4.43,0,1,1,6.26-6.27L32.07,39,55.51,15.58a4.43,4.43,0,0,1,6.26,6.27L35.2,48.42A4.42,4.42,0,0,1,32.07,49.71Z" />
  </Icon>
)

export default ChevronDown
